import { render, staticRenderFns } from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=template&id=143e149d&scoped=true&lang=pug"
import script from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=style&index=0&id=143e149d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e149d",
  null
  
)

export default component.exports